import ChartTypes from './chart_types';

export default {
	[ChartTypes.COLUNA]: "mscolumn3d",
	[ChartTypes.COLUNA_SIMPLES]: "column3d",
	[ChartTypes.PIZZA]: "pie3d",
	[ChartTypes.BARRA]: "msbar3d",
	[ChartTypes.DISPERSAO]: "msarea",
	[ChartTypes.LINHA]: "msline"
}
